// extracted by mini-css-extract-plugin
export default {"burgerMenu":"BurgerMenu_burgerMenu__ECzb+","content":"BurgerMenu_content__3P+aA","nav":"BurgerMenu_nav__ziwWX","social":"BurgerMenu_social__rpkuo"};